import { render, staticRenderFns } from "./Kirker.vue?vue&type=template&id=caba2276&"
import script from "./Kirker.vue?vue&type=script&lang=js&"
export * from "./Kirker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports